import * as React from "react";
import "./index.scss";

const Button: React.SFC<any> = ({ children, inline, highlight, disabled, type, onClick, id, loading, noColor }) => (
  <button
    type={type}
    id={id}
    onClick={onClick}
    className={`decode-button ${highlight && "decode-button--secundary"} ${inline && "decode-button--inline"} ${loading ? "loading" : "loaded"} ${noColor &&
      "decode-button--no-color"}`}
    disabled={disabled}
  >
    {children}
  </button>
);

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/index.tsx